import React from 'react'

const GridIcon: React.FC = () => {
  return (
      <div className="grid-icon" >
        {Array.from({ length: 9 }).map((_, i) => (
          <div key={i} className="grid-box" />
        ))}
      </div>
  )
}

export default GridIcon
